var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import $$observable from 'symbol-observable';

function observerPlugin(router) {
    var listeners = [];

    function unsubscribe(listener) {
        if (listener) {
            listeners = listeners.filter(function (l) {
                return l !== listener;
            });
        }
    }

    function _subscribe(listener) {
        var isObject = (typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) === 'object';
        var finalListener = isObject ? listener.next.bind(listener) : listener;

        listeners = listeners.concat(finalListener);

        var unsubscribeHandler = function unsubscribeHandler() {
            return unsubscribe(finalListener);
        };

        return isObject ? { unsubscribe: unsubscribeHandler } : unsubscribeHandler;
    }

    function observable() {
        return _defineProperty({
            subscribe: function subscribe(observer) {
                if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
                    throw new TypeError('Expected the observer to be an object.');
                }
                return _subscribe(observer);
            }
        }, $$observable, function () {
            return this;
        });
    }

    router.subscribe = _subscribe;
    router[$$observable] = observable;

    return {
        onTransitionSuccess: function onTransitionSuccess(toState, fromState) {
            listeners.forEach(function (listener) {
                return listener({
                    route: toState,
                    previousRoute: fromState
                });
            });
        }
    };
}

observerPlugin.pluginName = 'OBSERVABLE_PLUGIN';

export default function withObservablePlugin(router) {
    router.usePlugin(observerPlugin);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/router5/dist/es/core/observable.js
// module id = 968
// module chunks = 0